<template>
  <div class="sidebar-expanded">
    <div class="sidebar-expanded__top">
      <div class="sidebar-expanded__top__product-information">
        <instance-section-profile-card
          :mask-shade="false"
          :InstanceInfo="InstanceDetails">
        </instance-section-profile-card>
      </div>
    </div>
    <!-- end ~ sidebar-expanded__top -->
    <div class="sidebar-expanded__center">
      <div class="sidebar-expanded__menu">
        <nuttrema-el-menu
          :router="true"
          :default-active="$route.path"
          :unique-opened="true"
          class="el-menu--nuttrema-navigation-menu"
          @open="handleOpen"
          @close="handleClose">
          <template v-for="navigation in navigations">
            <el-submenu :index="navigation.url" :route="{ name: navigation.name }" v-if="navigation.type === 'section'">
              <template slot="title">
                <span>{{ $t(navigation.label) }}</span>
              </template>
              <nuttrema-el-menu-item v-for="(page, childIndex) in navigation.pages" :index="page.url" :type="page.type" :route="{ name: page.name }" :key="page.url">
                <i v-if="page.navigationIcon" :class="page.navigationIcon"></i>
                <span>{{ $t(page.label) }}</span>
              </nuttrema-el-menu-item>
            </el-submenu>
            <nuttrema-el-menu-item v-else :index="navigation.url" :type="navigation.type" :route="{ name: navigation.name }">
              <i v-if="navigation.navigationIcon" :class="navigation.navigationIcon"></i>
              <span class="is-title">{{ $t(navigation.label) }}</span>
            </nuttrema-el-menu-item>
          </template>
        </nuttrema-el-menu>
      </div>
    </div>
    <!-- end ~ sidebar-expanded__center -->

    <div v-if="showPurchaseNewSubscription" class="sidebar-expanded__bottom" style="padding: 1em">
      <el-button type="nuttrema-orange" class="w-100" @click="goto('instance-subscription-purchase-new')">{{ $t('label.purchase_new_subscription') }}</el-button>
    </div>
    <!-- end ~ sidebar-expanded__bottom -->
</div>
</template>

<script>
import { get, includes } from 'lodash';

import SidebarMenu from 'components/ui/menu/sidebar-menu';
import InstanceSectionProfileCard from 'components/ui/card/instance-section-profile-card';

import NuttremaElMenu from 'components/ui/navigation/nuttrema-el-menu';
import NuttremaElMenuItem from 'components/ui/navigation/nuttrema-el-menu-item';

export default {
  name: 'sidebar-menu-instance-expanded',
  mixins: [SidebarMenu],
  components: {
    NuttremaElMenu,
    NuttremaElMenuItem,
    InstanceSectionProfileCard,
  },
  props: {
    InstanceDetails: {
      type: Object,
      required: true,
      default: null,
    },
  },
  data() {
    return {
      startingUrl: '/professional/settings/instance/',
    };
  },
  computed: {
    InstanceSubscribedPlanSummarized() {
      return this.$store.getters.InstanceSubscribedPlanSummarized;
    },
    showPurchaseNewSubscription() {
      const instanceRestrictions = get(this.InstanceSubscribedPlanSummarized, 'data.instance_restrictions');
      return includes(['no_subscription', 'on_trial', 'in_grace'], instanceRestrictions);
    },
  },
  methods: {
    goto(name) {
      this.$router.push({ name });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/menu/instance/sidebar-menu-instance-expanded.vue